export default "__VITE_ASSET__68fbe7da__"